import { createSharedComposable, useKeyModifier } from "@vueuse/core";
import { isApple } from "ls/common/lib/browser";
import { Keys } from "ls/common/lib/keyboard";

function useIsModPressedFn() {
  const mod = isApple ? Keys.Meta : Keys.Control;
  const modPressed = useKeyModifier(mod, { initial: false });

  return modPressed;
}

export const useIsModPressed = createSharedComposable(useIsModPressedFn);
